import i18next from 'i18next'
import React from 'react'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../../../../utils/inview'
import { PictureLayout } from '../../../image/imageLayout'
import { homeInViewThreshold } from '../loggedOutHomeWidget'

export const HomeTextImageBlockLayout = () => (
  <InView
    as="section"
    threshold={homeInViewThreshold}
    triggerOnce={true}
    onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
    className="block block--home-text-image bg--secondary"
  >
    <div className="block__inner container--m gutter--m">
      <div className="block__content">
        <header className="block__header">
          <h2
            className="block__title title--m"
            dangerouslySetInnerHTML={{
              __html: i18next.t('home:textImageTitle'),
            }}
          />
        </header>

        <div className="block__text">
          <ul className="block__list list--hexagon list--hexagon-title">
            <li className="list__item">
              <h3 className="list__title">
                {i18next.t('home:textImageBulletPrimaryTitle')}
              </h3>
              <p className="list__text">
                {i18next.t('home:textImageBulletPrimaryText')}
              </p>
            </li>
            <li className="list__item">
              <h3 className="list__title">
                {i18next.t('home:textImageBulletSecondaryTitle')}
              </h3>
              <p className="list__text">
                {i18next.t('home:textImageBulletSecondaryText')}
              </p>
            </li>
            <li className="list__item">
              <h3 className="list__title">
                {i18next.t('home:textImageBulletTertiaryTitle')}
              </h3>
              <p className="list__text">
                {i18next.t('home:textImageBulletTertiaryText')}
              </p>
            </li>
            <li className="list__item">
              <h3 className="list__title">
                {i18next.t('home:textImageBulletQuaternaryTitle')}
              </h3>
              <p className="list__text">
                {i18next.t('home:textImageBulletQuaternaryText')}
              </p>
            </li>
          </ul>
        </div>
      </div>

      <figure className="block__visual fit-object">
        <PictureLayout.Img
          image={{
            Url: '/spa/images/chef-plates-dish-on-counter-small.jpg',
            Title: i18next.t('home:textImageImageAlt'),
          }}
          srcSet="/spa/images/chef-plates-dish-on-counter-small.jpg 480w, /spa/images/chef-plates-dish-on-counter-medium.jpg 960w, /spa/images/chef-plates-dish-on-counter-large.jpg 1920w"
          width="960"
          height="800"
          lazyload
        />
      </figure>
    </div>
  </InView>
)
